import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PublicComponent } from './public.component';
//import { ChangePasswordComponent } from '../shared/change-password/change-password.component';
//import { GeneralConditionsComponent } from '../affiliate/general-conditions/general-conditions.component';
//import { FatcaComponent } from '../affiliate/fatca/fatca.component';
import { BadRequestComponent } from './Errors/bad-request/bad-request.component';
import { ForbiddenComponent } from './Errors/forbidden/forbidden.component';
import { InternalFormsSharedModule } from '@angular/forms/src/directives';
import { InternalServerErrorComponent } from './Errors/internal-server-error/internal-server-error.component';
import { NotFoundComponent } from './Errors/not-found/not-found.component';
import { UnauthorizedComponent } from './Errors/unauthorized/unauthorized.component';
import { PublicGuardService } from './services/public-guard.service';
import { SessionExpiredComponent } from './Errors/session-expired/session-expired.component';
import { TokenChangePasswordComponent } from './token-change-password/token-change-password.component';

const PublicRoutes: Routes = [
    {
        path: '',
        component: PublicComponent,
        children: [
            {
                path: '',
                canActivate: [PublicGuardService],
                component: HomeComponent
            },
            {
                path: 'home',
                canActivate: [PublicGuardService],
                component: HomeComponent,
                data: {
                    title: 'TSr_Home'
                }
            },
            {
                path: 'tokenChangePassword',
                canActivate: [PublicGuardService],
                component: TokenChangePasswordComponent
            },
            {
                path: 'sessionExpired',
                component: SessionExpiredComponent,
                data: {
                    title: 'TSr_Session_Expired'
                }
            },
            {
                path: 'badRequest',
                component: BadRequestComponent,
                data: {
                    title: 'TSr_Bad_request'
                }
            },
            {
                path: 'forbidden',
                component: ForbiddenComponent,
                data: {
                    title: 'TSr_Forbidden'
                }
            },
            {
                path: 'internalServerError',
                component: InternalServerErrorComponent,
                data: {
                    title: 'TSr_Internal_server_error'
                }
            },
            {
                path: 'notFound',
                component: NotFoundComponent,
                data: {
                    title: 'TSr_Not_found'
                }
            },
            {
                path: 'unauthorized',
                component: UnauthorizedComponent,
                data: {
                    title: 'TSr_Unauthorized'
                }
            },
            {
                path: '**',
                redirectTo: '/public/notFound'
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(PublicRoutes)],
    exports: [RouterModule]
})
export class PublicRoutingModule { }
